import React, {useState} from 'react';
import SmbAuthModal from './SmbAuthModal';
import useSolutionType from '../../../components/hook/useSolutionType';
import useUrlParams from '../../../components/hook/useUrlParams';
import subscriptionUtils from '../../../utils/subscriptionUtils';
import smbUtils from '../../../utils/smbUtils';
import useFunctionType from '../../../components/hook/useFunctionType';

export default function AuthModal({auth}) {
  const {isUrlSimulation, isUrlSkinAnalysis} = useUrlParams();
  const {
    areOverdue,
    isOverdueSkinAnalysis,
    isOverdueSimulation,
  } = useSolutionType(auth);
  const {isSkincare} = useFunctionType(auth);
  const isOwner = subscriptionUtils.isOwnerRole(auth);
  const isScpActivationAllowed = smbUtils.isScpActivationAllowed(auth);

  const simulation = isOwner && isOverdueSimulation && isUrlSimulation;
  const skinAnalysis = isOwner && isOverdueSkinAnalysis && isUrlSkinAnalysis;
  const shouldShowModal =
    areOverdue ||
    simulation ||
    skinAnalysis ||
    (isSkincare && !isScpActivationAllowed);

  const [showAuthModal, setShowAuthModal] = useState(shouldShowModal);

  return (
    <SmbAuthModal
      auth={auth}
      showAuthModal={showAuthModal}
      setShowAuthModal={setShowAuthModal}
    />
  );
}
